<div class="uk-navbar-container premium-navbar">
    <div class="uk-container uk-container-expand nav-container">
        <nav uk-navbar class="uk-navbar">

            <div class="uk-navbar-left">
                <a routerLink="/" class="uk-navbar-item uk-logo logo">
                    <!-- Logo para Desktop -->
                    <img src="img/LogoFinal.png" alt="FluxoHost Logo" class="uk-visible@m"
                        style="max-height: 40px; width: auto; max-width: 300px; transition: all 0.3s ease;">
                    <!-- Logo para Mobile -->
                    <img src="img/LogoXb.png" alt="FluxoHost Logo" class="uk-hidden@m"
                        style="max-height: 35px; width: auto; transition: all 0.3s ease;">
                </a>
            </div>

            <div class="uk-navbar-center">
                <!-- Links com routerLinkActive para identificação da página -->
                <ul class="uk-navbar-nav uk-visible@m nav-links">
                    <li>
                        <a routerLink="/" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}"><span
                                class="nav-icon" uk-icon="icon: home; ratio: 0.9"></span>
                            Início</a>
                    </li>
                    <li>
                        <a><span class="nav-icon" uk-icon="icon: world; ratio: 0.9"></span>
                            Web <span uk-navbar-parent-icon></span></a>
                        <div class="uk-navbar-dropdown">
                            <ul class="uk-nav uk-navbar-dropdown-nav">
                                <li><a routerLink="/hosting">Hospedagem Web</a></li>
                                <li><a routerLink="/email-corporativo">Email corporativo</a></li>
                                <li><a routerLink="/domain">Registro de domínio</a></li>
                                <li><a routerLink="/servicos">Desenvolvimento</a></li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <a><span class="nav-icon" uk-icon="icon: server; ratio: 0.9"></span>
                            Infraestrutura <span uk-navbar-parent-icon></span></a>
                        <div class="uk-navbar-dropdown">
                            <ul class="uk-nav uk-navbar-dropdown-nav">
                                <li><a routerLink="/private-cloud">Private cloud</a></li>
                                <li><a href="https://angolanvpn.com/" target="_blank">VPN</a></li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <a routerLink="/produtos" routerLinkActive="active-link"><span class="nav-icon"
                                uk-icon="icon: thumbnails; ratio: 0.9"></span>
                            Produtos</a>
                    </li>
                    <li>
                        <a routerLink="/sobre-nos" routerLinkActive="active-link"><span class="nav-icon"
                                uk-icon="icon: info; ratio: 0.9"></span> Sobre
                            Nós</a>
                    </li>
                </ul>
            </div>

            <div class="uk-navbar-right">
                <div class="uk-navbar-item uk-visible@m">
                    <a href="https://q28hpkmheelk.upmind.app/login" target="_blank" class="client-area-btn">
                        <i class="fa-solid fa-circle-user uk-margin-small-right" style="font-size: 1.3rem;"></i> Área de Cliente
                    </a>
                </div>
                <a class="uk-navbar-toggle uk-hidden@m mobile-toggle" uk-navbar-toggle-icon
                    uk-toggle="target: #offcanvas-nav"></a>
            </div>

        </nav>
    </div>
</div>

<div id="offcanvas-nav" uk-offcanvas="mode: push; overlay: true; flip: true">
    <div class="uk-offcanvas-bar mobile-menu-bar">
        <button class="uk-offcanvas-close" type="button" uk-close></button>

        <div class="mobile-logo-container">
            <img src="img/LogoXb.png" alt="Logo" style="max-height: 60px; width: auto;">
        </div>

        <ul class="uk-nav uk-nav-default mobile-nav-links" uk-nav>
            <li><a routerLink="/" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}"><span
                        uk-icon="icon: home; ratio: 0.8"></span> Início</a></li>
            <li class="uk-parent">
                <a href="#"><span uk-icon="icon: world; ratio: 0.8"></span> Web</a>
                <ul class="uk-nav-sub">
                    <li><a routerLink="/hosting">Hospedagem Web</a></li>
                    <li><a routerLink="/email-corporativo">Email corporativo</a></li>
                    <li><a routerLink="/domain">Registro de domínio</a></li>
                    <li><a routerLink="/servicos">Desenvolvimento</a></li>
                </ul>
            </li>
            <li class="uk-parent">
                <a href="#"><span uk-icon="icon: server; ratio: 0.8"></span> Infraestrutura</a>
                <ul class="uk-nav-sub">
                    <li><a routerLink="/private-cloud">Private cloud</a></li>
                    <li><a href="https://angolanvpn.com/" target="_blank">VPN</a></li>
                </ul>
            </li>
            <li><a routerLink="/produtos" routerLinkActive="active-link"><span
                        uk-icon="icon: thumbnails; ratio: 0.8"></span> Produtos</a></li>
            <li><a routerLink="/sobre-nos" routerLinkActive="active-link"><span uk-icon="icon: info; ratio: 0.8"></span>
                    Sobre Nós</a></li>

            <li class="uk-margin-medium-top">
                <a href="https://q28hpkmheelk.upmind.app/login" target="_blank" class="client-area-btn mobile-btn">
                    <i class="fa-solid fa-circle-user uk-margin-small-right" style="font-size: 1.3rem;"></i> Área de Cliente
                </a>
            </li>
        </ul>
    </div>
</div>

